import { useLang, copy } from "@/i18n";
import { Reveal } from "@/components/Reveal";

export default function Archive() {
  const { lang } = useLang();
  const c = copy[lang].archive;

  return (
    <section
      id="archivio"
      data-testid="archive-section"
      className="px-6 md:px-14 py-[14vh] text-center"
      style={{ background: "rgba(6, 6, 5, 0.55)", color: "var(--bone)" }}
    >
      <Reveal>
        <h2
          data-testid="archive-kicker"
          className="font-mono-fmf text-xl md:text-2xl uppercase tracking-[0.35em]"
        >
          {c.kicker}
        </h2>
      </Reveal>

      <div className="mt-14 max-w-2xl mx-auto space-y-6">
        {c.paras.map((p, i) => (
          <Reveal key={i} delay={i * 0.12}>
            <p
              data-testid={`archive-para-${i}`}
              className="text-base md:text-lg leading-loose text-[var(--bone-dim)]"
            >
              {p}
            </p>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.3}>
        <p
          data-testid="archive-final"
          className="mt-[8vh] font-mono-fmf text-[15px] uppercase tracking-[0.5em] text-[var(--bone-dim)]"
        >
          {c.final}
        </p>
      </Reveal>
    </section>
  );
}
